import { render, staticRenderFns } from "./BuyerFull.vue?vue&type=template&id=ee82462a"
import script from "./BuyerFull.vue?vue&type=script&lang=js"
export * from "./BuyerFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports